function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.64 11.768a1 1 0 00.128-1.408l-4-5a1 1 0 00-1.536 0l-4 5a1 1 0 001.536 1.28L11 8.762V14a1 1 0 102 0V8.762l2.232 2.878a1 1 0 001.408.128z",
  fill: "#29354C"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 16,
  width: 12,
  height: 2,
  rx: 1,
  fill: "#29354C"
});

var SvgIconSubmitOutline = function SvgIconSubmitOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi42NDAyIDExLjc2ODJDMTcuMDY0NCAxMS40MTQ3IDE3LjEyMTggMTAuNzg0MSAxNi43NjgyIDEwLjM1OThMMTIuNzY4MiA1LjM1OTgyQzEyLjU3ODIgNS4xMzE4MiAxMi4yOTY4IDUgMTIgNUMxMS43MDMyIDUgMTEuNDIxNyA1LjEzMTgyIDExLjIzMTggNS4zNTk4Mkw3LjIzMTc1IDEwLjM1OThDNi44NzgxOSAxMC43ODQxIDYuOTM1NTEgMTEuNDE0NyA3LjM1OTc5IDExLjc2ODJDNy43ODQwNyAxMi4xMjE4IDguNDE0NjMgMTIuMDY0NSA4Ljc2ODIgMTEuNjQwMkwxMSA4Ljc2MjA1TDExIDE0QzExIDE0LjU1MjMgMTEuNDQ3NyAxNSAxMiAxNUMxMi41NTIzIDE1IDEzIDE0LjU1MjMgMTMgMTRMMTMgOC43NjIwNUwxNS4yMzE4IDExLjY0MDJDMTUuNTg1MyAxMi4wNjQ1IDE2LjIxNTkgMTIuMTIxOCAxNi42NDAyIDExLjc2ODJaIiBmaWxsPSIjMjkzNTRDIi8+CjxyZWN0IHg9IjYiIHk9IjE2IiB3aWR0aD0iMTIiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyOTM1NEMiLz4KPC9zdmc+Cg==";
export { SvgIconSubmitOutline as ReactComponent };